import { Protocol } from './index';
import { Category } from '../constants';

const nft: Protocol[] = [
  {
    name: 'The Plooshies',
    url: 'https://theplooshies.com/',
    logoPath: '/logos/plooshies.png',
    category: Category.NFT,
    twitterUrl: 'https://x.com/ThePlooshies',
  },
];

export { nft };
